
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { toast } from "sonner";
import { formatDateTime } from "./formatTimeDate";

const styles = {
  cardContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap"
  },
  headerCard: {
    background: "#f8f9fa",
    padding: "15px 20px",
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "10px",
    marginBottom: "20px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
  },
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    minWidth: "150px",
    textAlign: "center"
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    borderBottom: "1px solid #eee"
  },
  activityBox: {
    background: "#fafafa",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "8px"
  }
};

const Card = ({ title, value }) => (
  <div style={styles.card}>
    <h4>{title}</h4>
    <h2>{value}</h2>
  </div>
);

const Section = ({ title, children }) => (
  <div style={{ marginTop: "30px" }}>
    <h3>{title}</h3>
    <div>{children}</div>
  </div>
);

const RAGKeyAnalytics = ({ ragKey, activeCompany, activeDepartment }) => {
  const [data, setData] = useState(null);
  const [newLimit, setNewLimit] = useState("");
  const [updating, setUpdating] = useState(false);
  const [openUser, setOpenUser] = useState(null);
  const authToken = localStorage.getItem("rag_token");

  //invite section

  const [showInviteModal, setShowInviteModal] = useState(false);
const [inviteEmail, setInviteEmail] = useState("");
const [inviteRole, setInviteRole] = useState("user");
const [showUsersModal, setShowUsersModal] = useState(false);
const [invitedUsers, setInvitedUsers] = useState([]);
const [loadingUsers, setLoadingUsers] = useState(false);

  const toggleUser = (index) => {
  setOpenUser(openUser === index ? null : index);
};

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_RAG_SERVER_URL}/rag-api/rag/analytics/${ragKey}`,{ method: 'GET',
        credentials: 'include',
        headers: {
          "Authorization": `Bearer ${authToken}`,
        },});
        const result = await res.json();
        console.log("📊 Analytics response:", result);
        setData(result);
    } catch (err) {
      console.error(err);
    }
  };

//   const formatDateTime = (date) => {
//   const d = new Date(date);

//   const day = d.getDate();

//   // 👇 ordinal (st, nd, rd, th)
//   const getOrdinal = (n) => {
//     if (n > 3 && n < 21) return "th";
//     switch (n % 10) {
//       case 1: return "st";
//       case 2: return "nd";
//       case 3: return "rd";
//       default: return "th";
//     }
//   };

//   const dayWithSuffix = `${day}${getOrdinal(day)}`;

//   const month = d.toLocaleString("en-US", { month: "long" });
//   const year = d.getFullYear();

//   const time = d.toLocaleString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });

//   return `${dayWithSuffix} ${month} ${year}, ${time}`;
// };

  const updateKeyLimit = async () => {
    if (!newLimit) return;

    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Change limit from ${data?.maxUsage ?? "Unlimited"} → ${newLimit}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      confirmButtonText: "Yes, update it!",
    });

    if (!confirm.isConfirmed) return;

    try {
      setUpdating(true);

      const res = await fetch(
        `${process.env.REACT_APP_RAG_SERVER_URL}/rag-api/rag/update-limit/${ragKey}`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ limit: Number(newLimit) }),
        }
      );

      const resultData = await res.json();

      await Swal.fire({
        title: "Updated!",
        text: "Key limit updated successfully",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      // ✅ Update UI instantly
      setData((prev) => ({
        ...prev,
        maxUsage: Number(newLimit),
        remainingUsage: resultData.remainingUsage,
      }));

      // ✅ Reset input → placeholder updates
      setNewLimit("");

    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setUpdating(false);
    }
  };

  const groupedActivity = data?.recentActivity?.reduce((acc, item) => {
    const userKey = item?.userId || item?.name;

    if (!acc[userKey]) {
      acc[userKey] = {
        name: item?.name || "Unknown",
        questions: []
      };
    }

    acc[userKey].questions.push(item);
    return acc;
  }, {});

  const totalUsageByDate = data?.usageByDate?.reduce(
    (sum, item) => sum + item.count,
    0
  );

const handleInvite = async () => {
  if (!inviteEmail) {
    toast.warning("Please enter an email");
    return;
  }

  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAG_SERVER_URL}/rag-api/users/invite`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify({
          email: inviteEmail,
          key: ragKey
        })
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("Invitation sent successfully 🚀");
      setShowInviteModal(false);
      setInviteEmail("");
    } else {
      toast.error(data.message || "Failed to send invite");
    }

  } catch (err) {
    console.error(err);
    toast.error("Network error");
  }
};

const fetchInvitedUsers = async () => {
  try {
    setLoadingUsers(true);
    setShowUsersModal(true);

    const res = await fetch(
      `${process.env.REACT_APP_RAG_SERVER_URL}/rag-api/users/invited/${ragKey}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    );

    const data = await res.json();

    if (data.success) {
      setInvitedUsers(data.users);
    } else {
      toast.error(data.message);
    }

  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch users");
  } finally {
    setLoadingUsers(false);
  }
};

// const handleRemoveUser = async (userId) => {
//   try {
//     const res = await fetch(
//       `${process.env.REACT_APP_RAG_SERVER_URL}/api/users/remove`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${authToken}`
//         },
//         body: JSON.stringify({ key: ragKey, userId })
//       }
//     );

//     const data = await res.json();

//     if (data.success) {
//       toast.success("User removed");
//       setInvitedUsers(prev => prev.filter(u => u._id !== userId));
//     } else {
//       toast.error(data.message);
//     }

//   } catch (err) {
//     toast.error("Error removing user");
//   }
// };
const handleRemoveUser = async (userId) => {
  const confirm = await Swal.fire({
    title: "Remove User?",
    text: "This user will lose access to this key.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    confirmButtonText: "Yes, remove",
  });

  if (!confirm.isConfirmed) return;

  try {
    const res = await fetch(
      `${process.env.REACT_APP_RAG_SERVER_URL}/rag-api/users/remove`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify({ key: ragKey, userId })
      }
    );

    const data = await res.json();

    if (data.success) {
      toast.success("User removed successfully");

      // ✅ remove from UI instantly
      setInvitedUsers(prev => prev.filter(u => u._id.toString() !== userId.toString()));
    } else {
      toast.error(data.message);
    }

  } catch (err) {
    toast.error("Error removing user");
  }
};
const handleReinvite = async (email) => {
  setInviteEmail(email);
  await handleInvite();
};

  if (!data) return <p>Loading...</p>;

  return (
    <><div style={{ padding: "20px" }}>
      <h2>RAG Analytics Dashboard</h2>

      {/* HEADER */}
      <div style={styles.headerCard}>
        <div>
          <p><b>Key:</b> {ragKey}</p>
          <p><b>Limit:</b> {data?.maxUsage ?? "Unlimited"}</p>
          <p><b>Company:</b> {activeCompany || "N/A"}</p>
          <p><b>Department:</b> {activeDepartment || "N/A"}</p>
          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
  <button
    onClick={() => setShowInviteModal(true)}
    style={{
      padding: "8px 12px",
      borderRadius: "6px",
      background: "green",
      color: "#fff",
      border: "none",
      cursor: "pointer"
    }}
  >
    Invite User
  </button>

  <button
    onClick={fetchInvitedUsers}
    style={{
      padding: "8px 12px",
      borderRadius: "6px",
      background: "grey",
      color: "#fff",
      border: "none",
      cursor: "pointer"
    }}
  >
    Invited Users
  </button>
</div>
        </div>

        <div>
          <input
            type="number"
            placeholder={
              data?.maxUsage !== null && data?.maxUsage !== undefined
                ? `Current: ${data.maxUsage}`
                : "Unlimited"
            }
            value={newLimit}
            onChange={(e) => setNewLimit(e.target.value)}
            style={{
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              marginRight: "10px",
              width: "150px"
            }}
          />

          <button
            onClick={updateKeyLimit}
            disabled={
              updating ||
              !newLimit ||
              Number(newLimit) === data?.maxUsage
            }
            style={{
              padding: "8px 12px",
              borderRadius: "6px",
              background: updating ? "#ccc" : "#28a745",
              color: "#fff",
              border: "none",
              cursor: updating ? "not-allowed" : "pointer",
              opacity:
                updating ||
                !newLimit ||
                Number(newLimit) === data?.maxUsage
                  ? 0.6
                  : 1
            }}
          >
            {updating ? "Updating..." : "Set Key Limit"}
          </button>
        </div>
      </div>

      {/* SUMMARY */}
      <div style={styles.cardContainer}>
        <Card title="Total Usage" value={data?.totalUsage} />
        <Card title="Total Users" value={data?.totalUsers} />
        <Card title="Total Chats" value={data?.totalChatsUsage} />
        <Card title="Remaining Usage" value={data?.remainingUsage ?? "Unlimited"} />
      </div>

      {/* USAGE BY DATE */}
      <Section title="Usage by Date">
        <div style={{ ...styles.row, fontWeight: "bold" }}>
          <span>Total</span>
          <span>{totalUsageByDate}</span>
        </div>

        {data?.usageByDate?.map((item, i) => (
          <div key={i} style={styles.row}>
            <span>{item?._id}</span>
            <span>{item?.count}</span>
          </div>
        ))}
      </Section>

      {/* TOP USERS */}
      <Section title="Top Users">
        {data?.topUsers?.map((user) => (
          <div key={user.userId} style={styles.row}>
            <span><b>{user?.name}</b> ({user?.email})</span>
            <span>{user?.usage} requests</span>
          </div>
        ))}
      </Section>

      {/* RECENT ACTIVITY */}
      <Section title="Recent Activity">
        {Object.values(groupedActivity || {}).map((user, index) => {
  const isOpen = openUser === index;

  return (
    <div key={index} style={styles.activityBox}>

      {/* 🔹 USER HEADER */}
      <div
        onClick={() => toggleUser(index)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          cursor: "pointer",
          alignItems: "center"
        }}
      >
        <h4 style={{ margin: 0 }}>👤 {user.name}  <small>({user.questions.length})</small></h4>

        <span style={{ fontSize: "18px" }}>
          {isOpen ? "▼" : "▶"}
        </span>
      </div>

      {/* 🔹 EXPANDED MESSAGES */}
      {isOpen && (
        <div style={{ marginTop: "10px" }}>
          {user.questions.map((item, i) => (
            <div key={i} style={styles.activityBox}>
              <p><b>Q:</b> {item.question}</p>
              <small>{formatDateTime(item.usedAt)}</small>
            </div>
          ))}
        </div>
      )}

    </div>
  );
})}
      </Section>
    </div>
    {showInviteModal && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "100px",
    zIndex: 999
  }}>
    <div style={{
      background: "#fff",
      padding: "20px",
      borderRadius: "10px",
      width: "400px"
    }}>
      <h3>Invite User</h3>

      {/* Email */}
      <input
        type="email"
        placeholder="Enter email"
        value={inviteEmail}
        onChange={(e) => setInviteEmail(e.target.value)}
        style={{
          width: "100%",
          padding: "8px",
          marginBottom: "10px",
          borderRadius: "6px",
          border: "1px solid #ccc"
        }}
      />

      {/* Role */}
      {/* <select
        value={inviteRole}
        onChange={(e) => setInviteRole(e.target.value)}
        style={{
          width: "100%",
          padding: "8px",
          marginBottom: "15px",
          borderRadius: "6px"
        }}
      >
        <option value="user">User</option>
        <option value="partner">Partner</option>
        <option value="admin">Admin</option>
      </select> */}

      {/* Buttons */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button
          onClick={() => setShowInviteModal(false)}
          style={{ padding: "8px 12px" }}
        >
          Cancel
        </button>

        <button
          onClick={handleInvite}
          style={{
            padding: "8px 12px",
            background: "#28a745",
            color: "#fff",
            border: "none"
          }}
        >
          Send Invite
        </button>
      </div>
    </div>
  </div>
)}

{showUsersModal && (
  <div style={{
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  paddingTop: "80px",
  zIndex: 999
}}>
    <div style={{
  background: "#fff",
  borderRadius: "14px",
  width: "520px",
  maxHeight: "75vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 20px 50px rgba(0,0,0,0.15)"
}}>

  {/* HEADER */}
  <div style={{
    padding: "16px 20px",
    borderBottom: "1px solid #eee",
    fontWeight: "600",
    fontSize: "16px"
  }}>
    Invited Users
  </div>

  {/* BODY (scroll only here) */}
  <div style={{
    flex: 1,
    overflowY: "auto"
  }}>
    {loadingUsers ? (
      <p style={{ padding: "20px" }}>Loading...</p>
    ) : invitedUsers.length === 0 ? (
      <p style={{ padding: "20px" }}>No users invited</p>
    ) : (
      invitedUsers.map((user) => (
        <div key={user._id} style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 20px",
          borderBottom: "1px solid #f1f1f1"
        }}>
          <div>
            <div style={{ fontWeight: "500" }}>{user?.name}</div>
            <div style={{ fontSize: "12px", color: "#888" }}>
              {user?.email}
            </div>
          </div>

          <button
            onClick={() => handleRemoveUser(user?._id)}
            style={{
              background: "#fee2e2",
              color: "#dc2626",
              border: "none",
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              cursor: "pointer"
            }}
          >
            Remove
          </button>
        </div>
      ))
    )}
  </div>

  {/* FOOTER (always visible ✅) */}
  <div style={{
    padding: "12px 20px",
    borderTop: "1px solid #eee",
    textAlign: "right",
    background: "#fff"
  }}>
    <button
      onClick={() => setShowUsersModal(false)}
      style={{
        padding: "6px 12px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        background: "#fff",
        cursor: "pointer"
      }}
    >
      Close
    </button>
  </div>

</div>
  </div>
)}
    </>
    
    
  );
};

export default RAGKeyAnalytics;